var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.traitGroup,
          expression: "traitGroup",
        },
      ],
      staticClass: "form-control",
      on: {
        change: function ($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function (o) {
              return o.selected
            })
            .map(function (o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.traitGroup = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        },
      },
    },
    [
      !_vm.cvdi
        ? _c("option", { attrs: { value: "all" } }, [_vm._v("All")])
        : _vm._e(),
      !_vm.cvdi
        ? _c("option", { attrs: { value: "all_but_hpo" } }, [
            _vm._v("All but HPO"),
          ])
        : _vm._e(),
      !_vm.cvdi
        ? _c("option", { attrs: { value: "all_complex" } }, [
            _vm._v("Complex traits"),
          ])
        : _vm._e(),
      _vm._l(_vm.groups, function (group) {
        return _c("option", { domProps: { value: group[0] } }, [
          _vm._v(" " + _vm._s(group[1]) + " "),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }